import { render, staticRenderFns } from "./verifyProtocol.vue?vue&type=template&id=531e71f5&scoped=true"
import script from "./verifyProtocol.vue?vue&type=script&lang=js"
export * from "./verifyProtocol.vue?vue&type=script&lang=js"
import style0 from "./verifyProtocol.vue?vue&type=style&index=0&id=531e71f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e71f5",
  null
  
)

export default component.exports